import { AgResourceLanguage } from '../types';
import { orderDetails as EnUsOrderDetails } from '../en-us/orderDetails';

export const orderDetails: AgResourceLanguage['orderDetails'] = {
  ...EnUsOrderDetails,
  returnBackButton: 'Tillbaka till Beställningar',
  upcomingOrderDetails: {
    pageTitle: 'Abonnemangsbeställning',
    orderDefaultStatus: 'Obetald',
    orderInformation: {
      orderDateLabel: 'Beställningsdatum',
      subscriptionNameLabel: 'Abonnemang',
      statusLabel: 'Status',
      totalLabel: 'Totalt'
    },
    shipNowButton: 'Skicka Nu',
    skipShipmentButton: 'Hoppa över Leverans',
    changeDateButton: 'Beställningsdatum',
    subscriptionProductsList: 'Abonnemangsprodukter:',
    manageSubscriptionButton: 'Hantera Abonnemang',
    emptyOrders: {
      title: 'Engångs-tillägg',
      description:
        'Handla hela sortimentet av AG1-produkter och tillbehör, exklusivt tillgängliga för medlemmar.',
      buttonName: 'Lägg till Produkt i Beställning'
    },
    oneTimeField: {
      oneTimeProductsList: 'Engångs-tillägg',
      addProducrToOrderButton: 'Lägg till Produkt i Beställning',
      oneTimeSubtottal: 'Delsumma för Engångs-tillägg'
    }
  },
  pastOrdersDetails: {
    pageTitle: 'Beställning',
    freeGiftTitle: 'Dela Gratis Paket',
    orderItems: 'Beställningsartiklar',
    trackOrderButton: 'Spåra Beställning',
    subscriptionNameOTP: 'Engångsköp',
    defaultOrderStatus: 'Inte Tillgänglig',
    orderInformation: {
      orderDateLabel: 'Beställningsdatum',
      subscriptionNameLabel: 'Abonnemang',
      statusLabel: 'Status',
      totalLabel: 'Totalt'
    }
  },
  missingValue: 'Inte Tillgänglig'
};
